import React from "react";
import { Modal, Box, Button, TextField, Typography, Grid } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import constants from "../../common/constants";
import Colors from "../../utility/Colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const validationSchema = Yup.object({
  paidClaimAmount: Yup.number()
    .required("Required")
    .max(99999999999, "Maximum amount limit reached"),
  cost: Yup.number()
    .required("Required")
    .max(99999999999, "Maximum amount limit reached"),
  paidInterestAmount: Yup.number()
    .required("Required")
    .max(99999999999, "Maximum amount limit reached"),
  dateOfCompliance: Yup.date().required("Required"),
});

const ClosedFormDetailsModal = ({ open, handleClose, submitClickHandler }) => (
  <Modal open={open} onClose={handleClose}>
    <Box sx={style}>
      <Typography variant="h6" mb={2}>
        Compliance Details
      </Typography>
      <Formik
        initialValues={{
          paidClaimAmount: "",
          cost: "",
          paidInterestAmount: "",
          dateOfCompliance: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitClickHandler(values);
          setSubmitting(false);
          handleClose();
        }}
      >
        {(props, isSubmitting) => (
          <Form>
            <Grid container spacing={4} sx={{ p: 1, mt: 4 }}>
              {[
                {
                  name: "paidClaimAmount",
                  label: "Paid Claim Amount",
                  type: "input",
                },
                {
                  name: "cost",
                  label: "Cost",
                  type: "input",
                },
                {
                  name: "paidInterestAmount",
                  label: "Paid Interest Amount",
                  type: "input",
                },
                {
                  name: "dateOfCompliance",
                  label: "Date Of Compliance Order",
                  type: "date",
                },
              ].map((field) => (
                <>
                  {field?.type === "input" ? (
                    <Grid item size={{ xs: 12, md: 12 }} key={field.name}>
                      <Field name={field.name}>
                        {({ field: formikField, meta }) => (
                          <TextField
                            {...formikField}
                            variant="outlined"
                            size="small"
                            label={field.label}
                            type={
                              field.type === "checkbox" ? "checkbox" : "text"
                            }
                            fullWidth
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                          />
                        )}
                      </Field>
                    </Grid>
                  ) : field.type === "date" ? (
                    field.name === "dateOfCompliance" ? (
                      <Grid item size={{ xs: 12, md: 12 }} key={field.name}>
                        <Field name={field.name}>
                          {({ field: formikField, meta }) => (
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale="en-gb"
                            >
                              <DatePicker
                                {...field}
                                format="DD/MM/YYYY"
                                label={field.label}
                                disableFuture
                                value={props.values.dateOfCompliance || null}
                                onChange={(value) =>
                                  props.setFieldValue(field.name, value)
                                }
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    size: "small",
                                    error: Boolean(meta.error),
                                    helperText: meta.touched && meta.error,
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          )}
                        </Field>
                      </Grid>
                    ) : null
                  ) : null}
                </>
              ))}
            </Grid>

            {/* <Button onClick={openHandler}>Cancel</Button> */}
            <Grid
              container
              spacing={2}
              sx={{ p: 1 }}
              justifyContent="center"
              alignItems="center"
            >
              <Button
                sx={{
                  // ...background_orange_gradient,
                  borderRadius: "10px",
                  background: "rgb(245, 132, 31)",
                  color: Colors.WHITE,
                  px: 6,
                  my: 5,

                  borderRadius: "10px",
                  "&:hover": { opacity: 0.9 },
                }}
                type="submit"
                disabled={isSubmitting}
              >
                {"Close Case"}
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
      {/* <Formik
        initialValues={{
          paidClaimAmount: "",
          cost: "",
          paidInterestAmount: "",
          dateOfCompliance: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          submitClickHandler(values);
          setSubmitting(false);
          handleClose();
        }}
      >
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <Field
              as={TextField}
              name="paidClaimAmount"
              label="Paid Claim Amount"
              fullWidth
              size="small"
              margin="normal"
              error={touched.paidClaimAmount && Boolean(errors.paidClaimAmount)}
              helperText={touched.paidClaimAmount && errors.paidClaimAmount}
              type="number"
            />
            <Field
              as={TextField}
              name="cost"
              label="Cost"
              size="small"
              fullWidth
              margin="normal"
              error={touched.cost && Boolean(errors.cost)}
              helperText={touched.cost && errors.cost}
              type="number"
            />
            <Field
              as={TextField}
              name="paidInterestAmount"
              label="Paid Interest Amount"
              fullWidth
              size="small"
              margin="normal"
              error={
                touched.paidInterestAmount && Boolean(errors.paidInterestAmount)
              }
              helperText={
                touched.paidInterestAmount && errors.paidInterestAmount
              }
              type="number"
            />
            <Field
              as={TextField}
              name="dateOfCompliance"
              label="Date of Compliance of Order"
              fullWidth
              margin="normal"
              size="small"
              error={
                touched.dateOfCompliance && Boolean(errors.dateOfCompliance)
              }
              helperText={touched.dateOfCompliance && errors.dateOfCompliance}
              type="date"
              InputLabelProps={{ shrink: true }}
            />
            <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
              <Button
                onClick={handleClose}
                color="secondary"
                variant="outlined"
              >
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Submit
              </Button>
            </Box>
          </Form>
        )}
      </Formik> */}
    </Box>
  </Modal>
);

export default ClosedFormDetailsModal;
